import { formatAnalyticsCurrency } from "../shared/analyticsFormatting";

export const SERVICES_CONTENT_WIDTH = 1032;
export const SERVICES_CONTENT_MIN_HEIGHT = 552;
export const SERVICES_CONTENT_GAP = 24;
export const SERVICES_CONTENT_PADDING = 16;
export const SERVICES_INNER_WIDTH = 1000;
export const SERVICES_INNER_MIN_HEIGHT = 468;
export const SERVICES_PILLS_HEIGHT = 32;
export const SERVICES_CATEGORY_TABS_BG = "#F5F5F5";
export const SERVICES_CATEGORY_TABS_PADDING = 3;
export const SERVICES_CATEGORY_TABS_GAP = 8;
export const SERVICES_CATEGORY_TAB_HEIGHT = 24;

export const TOP_SERVICES_CARD_WIDTH = 572;
export const TOP_SERVICES_CARD_MIN_HEIGHT = SERVICES_INNER_MIN_HEIGHT;
export const TOP_SERVICES_CARD_RADIUS = 16;
export const TOP_SERVICES_CARD_GAP = 12;
export const TOP_SERVICES_CARD_PADDING_X = 16;
export const TOP_SERVICES_CARD_PADDING_TOP = 16;
export const TOP_SERVICES_CARD_PADDING_BOTTOM = 16;
export const TOP_SERVICES_CARD_BORDER = "#E5E5E5";
export const TOP_SERVICES_CARD_ICON_COLOR = "#CAC19F";

export const TOP_SERVICES_TABLE_ROW_HEIGHT = 72;
export const TOP_SERVICES_SERVICE_CELL_WIDTH = 120;

export const SERVICES_CATEGORY_TAB_ACTIVE_SHADOW =
  "shadow-[0px_1px_2px_-1px_rgba(0,0,0,0.1),0px_1px_3px_0px_rgba(0,0,0,0.1)]";

export const SERVICES_COLORS = {
  externalServices: "#CAC19F",
  guestServices: "#D4D4D4",
  activities: "#C4B5FD",
  guesteriaPartners: "#826BFF",
} as const;

export const SERVICES_PROGRESS_COLOR = "#CAC19F";
export const SERVICES_WEEKLY_USAGE_BAR_COLOR = "#E3DCC7";
export const SERVICES_WEEKLY_USAGE_BAR_HIGHLIGHT_COLOR = "#CAC19F";
export const SERVICES_REVENUE_COLOR = "#16A34A";
export const SERVICES_CHART_CARD_ICON_COLOR = "#9B90DA";

export const SERVICE_USAGE_CARD_WIDTH = 380;
export const SERVICE_USAGE_CARD_HEIGHT = SERVICES_INNER_MIN_HEIGHT;
export const SERVICE_USAGE_CARD_RADIUS = 16;
export const SERVICE_USAGE_CARD_GAP = 12;
export const SERVICE_USAGE_CARD_PADDING = 16;
export const SERVICE_USAGE_CARD_PADDING_BOTTOM = 1;
export const SERVICE_USAGE_CARD_BORDER = "#E5E5E5";

export {
  REVENUE_CHART_CARD_SHADOW,
  REVENUE_CHART_CARD_WIDTH,
  REVENUE_DONUT_CHART_SIZE,
  REVENUE_DONUT_SEGMENT_STROKE,
  REVENUE_DONUT_SEGMENT_STROKE_WIDTH,
} from "../revenue/constants";

export function formatServiceRevenue(value: number): string {
  return formatAnalyticsCurrency(value, {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
    symbol: "€",
    symbolPosition: "suffix",
  });
}
